import request from '@/utils/request'
export function relicSensorData(relicId){
    return request({
      url: `/shanDongScreen/${relicId}/relicSensorData`,
      method: 'get',
    })
  }
  